export default "__VITE_ASSET__sFjk7KBo__"